/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

/**
 * Module imports.
 */
import { ScrollingModule } from '@angular/cdk/scrolling';
import { WebRoutingModule } from './web-routing.module';
import { ShareModule } from '../common/commons.module';
import { PipesModule } from '../pipes/pipes.module';
import { FeedCardModule } from './feed-card/feed-card.module';
import { PostingModule } from './posting/posting.module';
import { AppHeaderModule } from '../common/header/header.module';
import { ClinicalResourceCardModule } from '../clinical-resource/clinical-resource-card/clinical-resource-card.module';
import { ProductMaskingCardModule } from '../common/product-masking-card/product-masking-card.module';
import { ConnectionCardModule } from '../connection/connection-card/connection-card.module';
import { WebFeedDetailModule } from '../common/web-feed-detail/web-feed-detail.module';
import { DrugSampleCardModule } from '../drug-sample/drug-sample-list/drug-sample-card/drug-sample-card.module';
import { EdetailModalModule } from '../e-detailing/edetail-modal/edetail-modal.module';
import { EDetailPharmaCardModule } from '../e-detailing/edetail-pharma-card/edetail-pharma-card.module';
import { SurveyFeedCardModule } from '../survey/survey-feed-card/survey-feed-card.module';
import { EdetailDrugCardModule } from '../e-detailing/edetail-drug-card/edetail-drug-card.module';
import { WebDoctalkCardModule } from '../web-doctalk/web-doctalk-list/web-doctalk-section/web-doctalk-card/web-doctalk-card.module';
import { BannerCardModule } from '../common/banner-card/banner-card.module';
import { WebEventsCardModule } from '../web-events/web-events-list/web-events-card/web-events-card.module';
import { WebinarCardModule } from '../webinar/webinar-list/webinar-section/webinar-card/webinar-card.module';
import { WebCmeCardModule } from '../web-cme/web-cme-card/web-cme-card.module';
import { WebChannelCardModule } from '../web-channel/web-channel-list/web-channel-section/web-channel-card/web-channel-card.module';
import { GameModule } from '../game/game.module';
import { AnalyticsEventModule } from '../analytics-event/analytics-event.module';
import { HcfModule } from '../hcf/hcf.module';

/**
 * Component imports.
 */
import { WebComponent } from './web.component';
import { FeedListComponent } from './feed-list/feed-list.component';
import { FeedDetailComponent } from './feed-detail/feed-detail.component';
import { PseRegisterComponent } from '../pse-register/pse-register.component';

/**
 * Directive imports.
 */
import { DirectivesModule } from '../directives/directives.module';
import { WebCommunityModule } from '../web-community/web-community.module';
/**
 * Import Chat Library Module
 */
import { ChatModule } from '../samvaad/chat/lib/chat.module';
import { StoriesModule } from '../stories/stories.module';
import { NudgesModule } from '../nudges/nudges.module';
import { ViewAllDocWebComponent } from './view-all-doc-web/view-all-doc-web.component';
import { PromoStripComponent } from './promo-strip/promo-strip.component';

@NgModule({
  imports: [
    FormsModule,
    HttpClientModule,
    CommonModule,
    WebRoutingModule,
    PipesModule,
    ScrollingModule,
    PostingModule,
    AppHeaderModule,
    ClinicalResourceCardModule,
    ProductMaskingCardModule,
    ConnectionCardModule,
    WebFeedDetailModule,
    DrugSampleCardModule,
    EdetailModalModule,
    EDetailPharmaCardModule,
    SurveyFeedCardModule,
    EdetailDrugCardModule,
    WebDoctalkCardModule,
    BannerCardModule,
    WebEventsCardModule,
    WebinarCardModule,
    WebCmeCardModule,
    FeedCardModule,
    WebChannelCardModule,
    AnalyticsEventModule,
    GameModule,
    DirectivesModule,
    WebCommunityModule,
    ChatModule,
    StoriesModule,
    NudgesModule,
    ShareModule,
    HcfModule
  ],
  declarations: [
    WebComponent,
    FeedListComponent,
    FeedDetailComponent,
    PseRegisterComponent,
    ViewAllDocWebComponent,
    PromoStripComponent

  ]
})
export class WebModule { }
